export enum AZURE_APPLICATION_PROXY_URLS {
    AuthenticationParameterKey = 'saml2idp',
    AuthenticationTargetEndPoint = 'https://sts.windows.net/5dbf1add-202a-4b8d-815b-bf0fb024e033/',
    ContentType = 'application/json',
}
